import React, { useState, useEffect } from 'react';
import useStockStore from '../../../stores/useStockStore';
import { useNavigate } from 'react-router-dom';
import { useBrokerIntegration } from '../../../contexts/BrokerIntegrationContextCompat';

const BrokerStatus = () => {
  const navigate = useNavigate();
  const { isConnected, toggleConnection } = useStockStore();
  const { deleteBrokerIntegration, brokerIntegrations } = useBrokerIntegration();

  const [userDisconnected, setUserDisconnected] = useState(false);
  const [showDisconnectModal, setShowDisconnectModal] = useState(false);

  // useEffect(() => {
  //   if (userDisconnected) {
  //     forceConnect();
  //     setUserDisconnected(false);
  //   } else {
  //     forceDisconnect();
  //   }
  // }, [userDisconnected, forceConnect, forceDisconnect]);

  const handleDisconnectConfirm = async () => {
    console.log('🔍 BrokerStatus handleDisconnectConfirm called');
    try {
      // Get the first active broker integration
      const activeIntegration = brokerIntegrations.find(integration => integration.status === 'active');
      if (activeIntegration) {
        console.log('🔍 Found active integration:', activeIntegration.id);
        await deleteBrokerIntegration(activeIntegration.id);
        console.log('✅ Broker disconnected successfully');
      } else {
        console.log('⚠️ No active broker integration found');
      }
      
      // ลบ engagement data จาก tbl_engagement ทันที
      console.log('🗑️ ลบ engagement data...');
      const { collection, query, where, getDocs, writeBatch } = await import('firebase/firestore');
      const { db, auth } = await import('../../../services/firebase');
      
      const userId = auth.currentUser?.uid;
      if (userId) {
        const engagementQuery = query(
          collection(db, 'tbl_engagement'),
          where('userId', '==', userId)
        );
        
        const snapshot = await getDocs(engagementQuery);
        console.log('🔍 พบ engagement documents:', snapshot.size);
        
        if (!snapshot.empty) {
          const batch = writeBatch(db);
          snapshot.docs.forEach((doc) => {
            console.log('🗑️ ลบ document:', doc.id);
            batch.delete(doc.ref);
          });
          
          await batch.commit();
          console.log(`✅ ลบ engagement documents เรียบร้อย: ${snapshot.size} documents`);
        }
      }
      
    } catch (error) {
      console.error('❌ Error disconnecting broker:', error);
    }
    setShowDisconnectModal(false);
    setUserDisconnected(true);
  };

  const handleConnectToggle = () => {
    if (isConnected) {
      setShowDisconnectModal(true);
    } else {
      toggleConnection();
      navigate('/broker-connect');
    }
  };

  return (
    <>
      <div className="flex items-center mb-2 w-full max-w-2xl bg-[#1e1e2f] p-4 rounded-lg shadow">
        <div className="flex items-center">
          <span className="text-white text-xs md:text-sm mr-2">Broker:</span>
          <button
            onClick={handleConnectToggle}
            className={`ml-0 h-6 px-2 text-xs rounded-md font-semibold
              ${isConnected ? 'bg-purple-500' : 'bg-red-500'} text-white
              hover:bg-opacity-80 transition-colors`}
          >
            {isConnected ? 'Connected' : 'To Connect'}
          </button>
        </div>
      </div>

      <p className="text-gray-400 text-xs mt-0">Results update after market hours</p>

      {showDisconnectModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center">
          <div className="bg-[#10151F] border border-gray-600 rounded-xl p-6 w-[90%] max-w-md shadow-xl text-white">
            <h2 className="text-xl font-bold mb-4">Broker Disconnect</h2>
            <p className="text-sm mb-6">
              Are you sure you want to disconnect your broker from Quantum Flo Auto Algo?
              Doing so will disable automated trading features, and any open positions will need to be managed manually.
            </p>
            <div className="flex justify-between gap-4">
              <button
                onClick={handleDisconnectConfirm}
                className="flex-1 py-2 bg-red-600 hover:bg-red-700 rounded font-semibold text-white"
              >
                Disconnect
              </button>
              <button
                onClick={() => setShowDisconnectModal(false)}
                className="flex-1 py-2 bg-green-500 hover:bg-green-600 rounded font-semibold text-white"
              >
                Stay connected
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BrokerStatus;
